import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Search, UserPlus, X, Crown } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { cacheGet } from "../../lib/offline";
import { num } from "../../lib/format";
import { tierOf } from "../../lib/loyalty";
import { Input } from "../ui/input";
import { Button } from "../ui/button";

export const CustomerPicker = ({ value, onChange }) => {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  const [adding, setAdding] = useState(false);
  const [nf, setNf] = useState({ name: "", phone: "" });

  useEffect(() => {
    if (!q.trim()) return setRows([]);
    const t = setTimeout(() => api.get("/customers", { params: { q } }).then((r) => setRows(r.data.slice(0, 5))).catch(() => {
      const s = q.toLowerCase();
      setRows((cacheGet("/customers") || []).filter((c) => c.name.toLowerCase().includes(s) || (c.phone || "").includes(s)).slice(0, 5));
    }), 250);
    return () => clearTimeout(t);
  }, [q]);

  const add = async () => {
    try {
      const { data } = await api.post("/customers", nf);
      onChange(data);
      setAdding(false);
      setNf({ name: "", phone: "" });
      toast.success("Member baru ditambahkan");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  if (value) {
    const [tier, color] = tierOf(value.total_spent || 0);
    return (
      <div className="flex items-center gap-3 rounded-xl border p-3" data-testid="selected-customer">
        <div className="h-9 w-9 rounded-full grid place-items-center text-white" style={{ background: color }}><Crown className="h-4 w-4" /></div>
        <div className="flex-1 min-w-0">
          <div className="text-sm font-semibold truncate">{value.name} <span className="text-xs font-normal text-muted-foreground">· {tier}</span></div>
          <div className="text-xs text-muted-foreground">{value.phone || value.code} · <b className="font-mono text-primary">{num(value.points)} poin</b></div>
        </div>
        <Button type="button" size="icon" variant="ghost" onClick={() => onChange(null)} data-testid="clear-customer-btn"><X className="h-4 w-4" /></Button>
      </div>
    );
  }
  if (adding)
    return (
      <div className="flex gap-2">
        <Input placeholder="Nama" value={nf.name} onChange={(e) => setNf({ ...nf, name: e.target.value })} data-testid="quick-customer-name" />
        <Input placeholder="No. HP" inputMode="tel" value={nf.phone} onChange={(e) => setNf({ ...nf, phone: e.target.value })} data-testid="quick-customer-phone" />
        <Button type="button" onClick={add} disabled={!nf.name} data-testid="quick-customer-save">Simpan</Button>
      </div>
    );
  return (
    <div className="relative">
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input className="pl-9" placeholder="Cari member (nama / no. HP)" value={q} onChange={(e) => setQ(e.target.value)} data-testid="customer-search-input" />
        </div>
        <Button type="button" variant="outline" size="icon" onClick={() => setAdding(true)} title="Member baru" data-testid="quick-add-customer-btn"><UserPlus className="h-4 w-4" /></Button>
      </div>
      {rows.length > 0 && (
        <div className="absolute z-10 mt-1 w-full rounded-xl border bg-popover shadow-lg overflow-hidden">
          {rows.map((c) => (
            <button type="button" key={c.id} className="w-full text-left px-3 py-2 hover:bg-accent text-sm flex justify-between" onClick={() => { onChange(c); setQ(""); }} data-testid={`customer-option-${c.id}`}>
              <span>{c.name} <span className="text-muted-foreground text-xs">{c.phone}</span></span>
              <span className="font-mono text-xs text-primary">{num(c.points)} poin</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
